import { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import Sidebar from "../components/Sidebar"
import DashboardHeader from "../components/DashboardHeader"
import ProfileSettings from "../components/settings/ProfileSettings"
import PasswordSettings from "../components/settings/PasswordSettings"
import SocialProfileSettings from "../components/settings/SocialProfileSettings"
import BillingSettings from "../components/settings/BillingSettings"
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const SettingsPage = () => {
  const { tab } = useParams()
  const navigate = useNavigate()
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [activeTab, setActiveTab] = useState("profile")
  const [profilePhoto, setProfilePhoto] = useState(null);

  const user = useSelector((state) => state.auth.user)
  const userData = {
    name: user?.username || "User",
    initials: user?.username?.slice(0, 2).toUpperCase() || "U",
    notificationCount: 4,
  }

  // Fetch profile photo separately
    useEffect(() => {
      const fetchUserProfile = async () => {
        try {
          const token = localStorage.getItem("access");
          const res = await axios.get(`${BASE_URL}/users/profile/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const p = res.data.profile_photo;
          if (p) {
            setProfilePhoto(
              p.startsWith("http") ? p : `${BASE_URL}${p}`
            );
          } else {
            setProfilePhoto(null);
          }
        } catch (e) {
          setProfilePhoto(null);
        }
      };
      fetchUserProfile();
    }, []);

  useEffect(() => {
    setActiveTab(tab || "profile")
  }, [tab])

  const handleTabChange = (tabName) => {
    setActiveTab(tabName)
    navigate(`/settings/${tabName}`)
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case "profile":
        return <ProfileSettings />
      case "password":
        return <PasswordSettings />
      case "social-profile":
        return <SocialProfileSettings />
      case "billing":
        return <BillingSettings />
      default:
        return <ProfileSettings />
    }
  }

  return (
    <div className="dashboard-container">
      <div className="d-flex">
        <Sidebar collapsed={sidebarCollapsed} toggleSidebar={() => setSidebarCollapsed((prev) => !prev)}/>
        <div className="main-content flex-grow-1">
          <DashboardHeader user={user} profilePhoto={profilePhoto} onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />
          <div className="dashboard-content p-4">
            <h2 className="dashboard-title mb-4">Settings</h2>
            <div className="settings-container">
              <div className="settings-tabs mb-4">
                <ul className="nav nav-tabs">
                  {["profile", "password", "social-profile", "billing"].map((key) => (
                    <li className="nav-item" key={key}>
                      <button
                        className={`nav-link ${activeTab === key ? "active" : ""}`}
                        onClick={() => handleTabChange(key)}
                      >
                        {key.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="settings-content">{renderTabContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SettingsPage
